export const HUBSPOT_DEFINED = 'HUBSPOT_DEFINED';
export const USER_DEFINED = 'USER_DEFINED';
export const INTEGRATOR_DEFINED = 'INTEGRATOR_DEFINED';